<template>
	<div>
		<div v-show="Receivable">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">回款数据分析表</div>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
				<!-- 查询框 -->
				<div style="margin-left:3%">
					<div style="height:10px"></div>
					<div style="display:inline-block;margin-top:20px">
						<span>组织架构</span>
						<el-cascader v-model="project_id" @change="changeCascader" clearable
							style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>
					</div>

					<div style="display:inline-block;margin-top:20px;margin-left:20px">
						<span>日期 </span>
						<el-date-picker v-model="contract_start_date" type="daterange" range-separator="至"
							start-placeholder="开始日期" format="yyyy-MM-dd" end-placeholder="结束日期"
							value-format="yyyy-MM-dd">
						</el-date-picker>
					</div>


					<!-- 按钮 -->
					<div style="display:inline-block;margin:20px;">
						<el-button type="goon" @click="Find">查询</el-button>
						<div style="display:inline-block;margin-left:190px">
							<download-excel class="export-excel-wrapper" :fields="download_excel" title="调岗人员清单"
								name="调岗人员清单.xls" :fetch="ExportForm" style="margin-left:-180px;top:100px">
								<el-button type="goon"
									style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
									导出</el-button>
							</download-excel>
						</div>
					</div>
				</div>

				<!-- 表格 -->
				<div style="margin:2% 3% 0 3%">
					<el-table :header-cell-style="{background:'#d4e9e2',color:'#000000'}"
						:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
						style="width: 100%;" height="570" @selection-change="handleSelectionChange" border>
						<el-table-column prop="organizeName" align="center" label="架构" width="150"></el-table-column>
						<el-table-column prop="" align="center" :label="title">
							<el-table-column prop="plannedRepaymentAmount" align="center" label="计划回款额">
							</el-table-column>
							<el-table-column prop="plannedActualPaymentCollection" align="center" label="计划内实际回款">
							</el-table-column>
							<el-table-column prop="difference" align="center" label="差额"></el-table-column>
							<el-table-column prop="" align="center" label="超额回款">
								<el-table-column prop="withinTheMonthlyPlan" align="center" label="月计划内">
								</el-table-column>
								<el-table-column prop="monthlyUnplanned" align="center" label="月计划外"></el-table-column>
							</el-table-column>
						</el-table-column>
						<el-table-column prop="" align="center" label="汇总">
							<el-table-column prop="totalPlannedCollectionAmount" align="center" label="计划回款额">
							</el-table-column>
							<el-table-column prop="" align="center" label="实际回款额">
								<el-table-column prop="plannedActualPaymentCollectionTotal" align="center"
									label="计划内实际回款" width="120"></el-table-column>
								<el-table-column prop="unplannedOverpayment" align="center" label="计划外超额回款" width="120">
								</el-table-column>
								<el-table-column prop="actualTotalAmountReceived" align="center" label="实际回款总额"
									width="120"></el-table-column>
							</el-table-column>
							<el-table-column prop="totalDifference" align="center" label="实际回款 - 计划回款" width="160">
							</el-table-column>
							<el-table-column prop="planCompletionRate" align="center" label="计划完成度"></el-table-column>
							<el-table-column prop="planPaymentAccuracy" align="center" label="计划回款准确度">
							</el-table-column>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
				total: 0,
				tableData: [],
				title: '',
				defaultDate: '',
				download_excel: {},
				// 权限
				Receivable: true,
				showedit: false,
				editList: {},
				ids: [],
				//条件
				condition: {
					organize_ids: '',
					contract_start_date: '',
					contract_end_date: '',
				},
				contract_start_date: [],
				project_id: [],

				//回显查询岗位
				project_ide: '',

				//组织架构数据
				organizeList: [],

				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
					multiple: false,
				},
			};
		},
		methods: {
			//组织架构选择
			changeCascader() {
				this.condition.organize_ids = this.project_id[this.project_id.length - 1];
			},
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach(item => {
					this.ids.push(item.id);
				});
			},
			// 弹窗
			// handleClose() {
			//     this.dialogVisible = false
			// },
			Return() {
				this.showadd = false;
				this.Receivable = true;
				this.trash();
				this.Find();
			},

			// 操作编辑
			edit(e) {
				this.editList = e;
				this.Receivable = false;
				this.showedit = true;
			},
			//查询
			async Find() {
				if (this.contract_start_date != null && this.contract_start_date != '') {
					this.condition.contract_start_date = this.contract_start_date != null && this
						.contract_start_date != '' ? this.contract_start_date[0] + '-01' : '';
					this.condition.contract_end_date = this.contract_start_date != null && this.contract_start_date !=
						'' ? this.contract_start_date[1] + '-01' : '';
				}
				var data = await this.$globals.AxiosPost('AccountsInvoiceRegistration/getAnalysis', this.condition);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.title = data.table;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			//获取当前时间
			getNowTime() {
				var now = new Date();
				var year = now.getFullYear(); //得到年份
				var month = now.getMonth(); //得到月份
				var date = now.getDate(); //得到日期
				month = month + 1;
				month = month.toString().padStart(2, "0");
				date = date.toString().padStart(2, "0");
				var defaultDate = `${year}-${month}-${date}`;
				this.condition.contract_start_date = defaultDate;
				this.condition.contract_end_date = defaultDate;
			},

			// 导表
			async ExportForm() {
				var temporary = [];
				this.condition.organize_ids.forEach(item => {
					temporary.push(item[item.length - 1]);
				})
				var organize_ids = "";
				temporary.forEach(item => {
					organize_ids += item + ",";
				})

				var url = 'StaffTransfer/selectAlls';
				var record = {
					data_grouping: 'Receivable',
					organize_ids: organize_ids,
					city_id: this.condition.staff.city_id,
					create_time: this.condition.create_time,
					state: this.condition.state,
					applicant_id: this.$globals.user.staff_id,
					staff_name: this.condition.staff.staff_name,
					staff_card: this.condition.staff.staff_card,
					applicant_id: this.$globals.user.staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if (data.length > 0) {
							this.$message.success("导表成功！文件下载中！");
							return data;
						} else {
							this.$message.success("没有可以导出的数据！");
							return null;
						}

					} else {
						this.$message.warning(data);
					}
				}
			},

			// 操作删除
			async Del(e) {
				var ids;
				if (e === null || e === "" || e === undefined) {
					if (this.ids === null || this.ids.length <= 0) {
						this.$message.warning("请先选择操作数据！");
						return false;
					}
					ids = this.ids;
				} else {
					ids = [e];
				}

				var url = "StaffTransfer/del";
				var record = {
					ids: ids,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.trash();
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
			},
			closeedit() {
				this.showedit = false;
				this.Receivable = true;
			},
			//分页
			handleCurrentChange(val) {
				this.condition.page_num = val;
				this.Find();
			},
			//初始化组织架构及下面的人
			async organizeFind() {
				var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
					identification: "1",
				});
				this.organizeList = this.getTreeData(organizeList.data);

			},
			getTreeData(data) {
				// 循环遍历json数据
				for (var i = 0; i < data.length; i++) {

					if (data[i].organizeList.length < 1) {
						// children若为空数组，则将children设为undefined
						data[i].organizeList = undefined;
					} else {
						// children若不为空数组，则继续 递归调用 本方法
						this.getTreeData(data[i].organizeList);
					}
				}
				return data;
			}
		},
		async created() {
			this.getNowTime();
			this.Find();
			this.organizeFind();
		},
	};
</script>

<style>
	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006e4b;
		border-color: #05573d;
		color: #fff;
	}

	.el-button--addbtn:focus,
	.el-button--addbtn:hover {
		background: #fff;
		border-color: #05573d;
		color: #006e4b;
	}

	.el-button--goon {
		color: #fff;
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-button--addbtn {
		color: #006e4b;
		background-color: #fff;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #006e4b;
		border-color: #006e4b;
	}

	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #006e4b;
	}

	.el-checkbox__inner:hover {
		border-color: #006e4b;
	}

	.el-button--pic {
		color: #006E4B;
		background-color: #fff;
		border-color: #006E4B;
		font-size: 10px;
		height: 30px;
		width: 70px;
		padding: 10px;
	}

	.el-button--pic:focus,
	.el-button--pic:hover {
		background: #fff;
		border-color: #05573d;
		color: #006E4B;
	}
	
	
</style>



// WEBPACK FOOTER //
// Collectiondata.vue?95013f8a